import { api } from './api';

export interface TtdSummary {
  corrente: number;
  intermediario: number;
  aptoEliminacao: number;
  recolhidoPermanente: number;
  eliminado: number;
  total: number;
}

export interface TtdDocument {
  _id: string;
  name: string;
  pages?: number;
  size?: number;
  createdAt: string;
  documentDate?: string;
  currentPhaseUntil?: string;
  intermediatePhaseUntil?: string;
  retentionStatus: 'corrente' | 'intermediario' | 'apto_eliminacao' | 'recolhido_permanente' | 'eliminado';
  eliminationLog?: {
    eliminatedAt?: string;
    termNumber?: string;
    justification?: string;
  };
  documentTypeInfo?: {
    name: string;
    classificationCode?: string;
    finalDestination?: 'permanente' | 'eliminacao';
    legalBasis?: string;
  };
  ownerInfo?: {
    name: string;
  };
}

export interface CpadTerm {
  _id: string;
  termNumber: string;
  type: 'eliminacao' | 'recolhimento_permanente';
  evaluationDate: string;
  committeeMembers: string[];
  justification: string;
  legalBasis?: string;
  documentCount: number;
  documents?: any[];
  responsibleUser?: {
    name: string;
    email: string;
  };
  createdAt: string;
}

export const ttdService = {
  getStatusSummary: async (): Promise<{ data: TtdSummary }> => {
    const response = await api.get('/ttd/summary');
    return response.data;
  },

  listDocuments: async (params?: {
    status?: string;
    page?: number;
    perPage?: number;
    search?: string;
  }) => {
    const response = await api.get('/ttd/documents', { params });
    return response.data;
  },

  updateDocumentTtd: async (documentId: string, data: { documentDate: string; retentionStatus?: string }) => {
    const response = await api.put(`/ttd/documents/${documentId}`, data);
    return response.data;
  },

  recalculateAll: async () => {
    const response = await api.post('/ttd/recalculate-all');
    return response.data;
  },

  createCpadTerm: async (data: {
    termNumber: string;
    type?: 'eliminacao' | 'recolhimento_permanente';
    evaluationDate?: string;
    committeeMembers?: string[];
    justification: string;
    legalBasis?: string;
    documentIds: string[];
  }) => {
    const response = await api.post('/ttd/cpad/terms', data);
    return response.data;
  },

  listCpadTerms: async (): Promise<{ data: CpadTerm[] }> => {
    const response = await api.get('/ttd/cpad/terms');
    return response.data;
  },

  getCpadTermById: async (id: string): Promise<{ data: CpadTerm }> => {
    const response = await api.get(`/ttd/cpad/terms/${id}`);
    return response.data;
  },
};
